import * as React from 'react';

import { getTermValue } from '../../../../../JsonQuery';
import { OfferType } from '../../../components/advancedFilters/OfferType';
import { useContext } from '../../../utils/useContext';

export const OfferTypeContainer: React.FC = () => {
  const { jsonQuery, specialPromo, onChange } = useContext();
  const fromDeveloper = getTermValue('from_developer')(jsonQuery);
  const isSpecialPromoActive =
    jsonQuery.geo && specialPromo
      ? jsonQuery.geo.value.some(value => value.type === 'builder' && value.id === specialPromo.developerId)
      : null;

  const handleFromDeveloperChange = React.useCallback(
    (fromDeveloper: boolean | null) => {
      onChange({ action: 'setFromDeveloper', arguments: [fromDeveloper] });
    },
    [onChange],
  );

  const handleSpecialPromoChange = React.useCallback(
    (isSpecialPromoActive: boolean | null) => {
      if (!specialPromo) {
        return;
      }

      if (isSpecialPromoActive) {
        onChange({ action: 'selectGeo', arguments: [{ type: 'builder', id: specialPromo.developerId }] });
      } else {
        onChange({ action: 'removeGeo', arguments: [{ type: 'builder', id: specialPromo.developerId }] });
      }
    },
    [onChange, specialPromo],
  );

  return (
    <OfferType
      fromDeveloper={fromDeveloper}
      specialPromoLabel={specialPromo ? specialPromo.filterLabel : null}
      specialPromoActive={isSpecialPromoActive}
      onFromDeveloperChange={handleFromDeveloperChange}
      onSpecialPromoChange={handleSpecialPromoChange}
    />
  );
};
